import { ProgramNames } from '../../../models/programs/Programs'
import { PROVIDER_TYPES } from '../../../models/providers/Providers'
import { PROGRAM_TAXONOMY, ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { LTSessionTypes } from '../../sessions/constants'
import { ConsentText, ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const SUBSTANCE_USE_EVALUATION_PROGRAM = {
  programName: ProgramNames.SubstanceUseEvaluation,
  blendedCareProgramId: '98d41c21-e865-4411-a3b2-60446305731e',
  customerPropertyId: ProgramCustomerPropertyId.substanceUseEvaluation,

  displayLabels: {
    default: ProgramDisplayLabels.substanceUseEvaluation,
    short: 'SAP',
    clientProfile: 'Substance Use Evaluation',
    sessionSummary: 'substance use evaluation',
  },

  associatedProviderTypes: [PROVIDER_TYPES.LYRACLINICALLEAVEEVALUATOR.lyraType],
  associatedProviderModalities: ['substanceUseEvaluation'],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  sessionTypeConfig: {
    sessionType: LTSessionTypes.INITIAL_SAP_SESSION,
    followupSessionType: LTSessionTypes.FOLLOWUP_SAP_SESSION,
    rateStrategy: 'fixed',
  },

  directBookingParams: {
    clientele: PROGRAM_TAXONOMY.clientele.individual,
    treatment: PROGRAM_TAXONOMY.treatment.assessment,
    partner: PROGRAM_TAXONOMY.partner.blendedCare,
    offering: PROGRAM_TAXONOMY.offering.sap,
  },

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.SUBSTANCE_USE_EVALUATION],
    isFullTreatmentOption: true,
  },

  consents: [
    {
      consentText: ConsentText.therapyConsent,
      consentUrl: 'https://www.lyrahealth.com/sap-agreement/',
      showConsentIf: () => true,
    },
  ],

  noteContentMetadataName: {
    INITIAL_NOTE: 'sapInitialNote',
    SESSION_NOTE: 'sapSessionNote',
    GENERAL_NOTE: 'sapGeneralNote',
    REFERRAL_NOTE: 'baseReferralNote',
  },
} satisfies ProgramConfig
